import * as i0 from '@angular/core';
import * as i1 from './buttons.module';
import * as i2 from './label';
import * as i3 from './checkbox';
import * as i4 from './radio';
export const NgbButtonsModuleNgFactory:i0.NgModuleFactory<i1.NgbButtonsModule> = (null as any);
var _decl0_0:i2.NgbButtonLabel = (<any>(null as any));
var _decl0_1:i3.NgbCheckBox = (<any>(null as any));
var _decl0_2:i4.NgbRadioGroup = (<any>(null as any));
var _decl0_3:i4.NgbRadio = (<any>(null as any));
